import { render, staticRenderFns } from "./RecordMessageShow.vue?vue&type=template&id=241ed352&scoped=true&"
import script from "./RecordMessageShow.vue?vue&type=script&lang=js&"
export * from "./RecordMessageShow.vue?vue&type=script&lang=js&"
import style0 from "./RecordMessageShow.vue?vue&type=style&index=0&id=241ed352&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "241ed352",
  null
  
)

export default component.exports